import { BrowserRouter } from 'react-router-dom';
import BrowserRoutes from './routes/BrowserRoutes';
import Layout from './hocs/Layout';
import { Provider } from "react-redux";
import store from './store';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnLocationChange from './components/ScrollToTopOnLocationChange';
import Head from './hocs/Head';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Head />
        <Layout>
          <ScrollToTop />
          <ScrollToTopOnLocationChange />
          <BrowserRoutes />
        </Layout>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
